global.conmed = global.conmed || {};

conmed.responsive_product_overview_img_source = function ($) {
    'use strict';
    var that = {
        selectors: {
            img: '.js-bg-responsive-product-overview-img-source',
        }
    };

    that.init = function () {

        let images = $(that.selectors.img);

        images.each(that.setImgSize);

        $(window).on("resize", function() {
            if (that.delay) {
                clearTimeout(that.delay);
            }

            that.delay = setTimeout(function () {
                images.each(that.setImgSize);
            }, 500);
        });
    };

    that.setImgSize = function () {

        let elm = $(this);

        let sm = elm.data("img-sm");
        let md = elm.data("img-md");
        let lg = elm.data("img-lg");

        let result;

        if (window.innerWidth >= 992) {
            result = lg;
        }
        else if (window.innerWidth >= 768 && window.innerWidth <= 992) {
            result = md;
        }
        else {
            result = sm;
        }

        elm.attr("src", result);
    };

    return that;
}(jQuery);